import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import { useAdminStore, AdminTab } from '../../stores/adminStore'
import AccreditationReviewTab from './tabs/AccreditationReviewTab'
import TransactionLedgerTab from './tabs/TransactionLedgerTab'
import PayoutManagementTab from './tabs/PayoutManagementTab'
import DisputeHandlingTab from './tabs/DisputeHandlingTab'
import DiveDisputesTab from './tabs/DiveDisputesTab'
import SupportTicketsTab from './tabs/SupportTicketsTab'
import DiveModerationTab from './tabs/DiveModerationTab'
import RatingModerationTab from './tabs/RatingModerationTab'
import UserManagementTab from './tabs/UserManagementTab'
import AuditLogTab from './tabs/AuditLogTab'
import DiveSitesTab from './tabs/DiveSitesTab'
import TestDataTab from './tabs/TestDataTab'

const TAB_CONFIG: { value: AdminTab; label: string }[] = [
  { value: 'accreditation', label: 'Accreditations' },
  { value: 'transactions', label: 'Transactions' },
  { value: 'payouts', label: 'Payouts' },
  { value: 'disputes', label: 'Disputes' },
  { value: 'diveDisputes', label: 'Dive Disputes' },
  { value: 'support', label: 'Support' },
  { value: 'dives', label: 'Dives' },
  { value: 'diveSites', label: 'Dive Sites' },
  { value: 'ratings', label: 'Ratings' },
  { value: 'users', label: 'Users' },
  { value: 'auditLog', label: 'Audit Log' },
  { value: 'testData', label: '🧪 Test Data' }
]

const renderTabContent = (activeTab: AdminTab) => {
  switch (activeTab) {
    case 'accreditation':
      return <AccreditationReviewTab />
    case 'transactions':
      return <TransactionLedgerTab />
    case 'payouts':
      return <PayoutManagementTab />
    case 'disputes':
      return <DisputeHandlingTab />
    case 'diveDisputes':
      return <DiveDisputesTab />
    case 'support':
      return <SupportTicketsTab />
    case 'dives':
      return <DiveModerationTab />
    case 'diveSites':
      return <DiveSitesTab />
    case 'ratings':
      return <RatingModerationTab />
    case 'users':
      return <UserManagementTab />
    case 'auditLog':
      return <AuditLogTab />
    case 'testData':
      return <TestDataTab />
  }
}

const AdminPanel = () => {
  const activeTab = useAdminStore(s => s.activeTab)
  const setActiveTab = useAdminStore(s => s.setActiveTab)

  return (
    <Box sx={{ width: '100%', p: 2 }}>
      <Typography variant='h5' sx={{ mb: 2 }}>
        Admin Panel
      </Typography>

      <Tabs
        value={activeTab}
        onChange={(_, newValue: AdminTab) => setActiveTab(newValue)}
        variant='scrollable'
        scrollButtons='auto'
        aria-label='Admin panel tabs'
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
      >
        {TAB_CONFIG.map(tab => (
          <Tab key={tab.value} value={tab.value} label={tab.label} />
        ))}
      </Tabs>

      {renderTabContent(activeTab)}
    </Box>
  )
}

export default AdminPanel
